import React from 'react';
import { WORKSHOP_OPERATOR_ROLE_LABELS } from '../../lib/workshopOperatorView';

/**
 * Choix du poste atelier lorsque l’utilisateur a plusieurs sous-rôles opérateur actifs.
 */
export default function WorkshopStationRolePicker({ stationRoles, activeRole, onChange }) {
  if (!stationRoles?.length || stationRoles.length < 2) return null;

  return (
    <div className="rounded-xl border border-primary/25 bg-primary/5 px-3 py-2.5 space-y-2">
      <p className="text-xs font-medium text-muted-foreground">Poste de travail</p>
      <div className="flex flex-wrap gap-2" role="group" aria-label="Poste de travail">
        {stationRoles.map((roleType) => {
          const selected = activeRole === roleType;
          const label = WORKSHOP_OPERATOR_ROLE_LABELS[roleType] ?? roleType;
          return (
            <button
              key={roleType}
              type="button"
              onClick={() => onChange(roleType)}
              className={`min-h-[44px] px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                selected
                  ? 'bg-primary text-primary-foreground shadow-sm'
                  : 'bg-card border border-border text-foreground hover:bg-muted'
              }`}
              aria-pressed={selected}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
